module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/png@2x/chart_scatter_with_smooth_lines2@2x-b8e1ad.png";